"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
}); //# sourceMappingURL=LoggerLike.js.map
